import(/* webpackMode: "eager" */ "/codebuild/output/src1992310932/src/apps/junonkuji/src/app/error.tsx");
